// extracted by mini-css-extract-plugin
export default {"txhd1":"HomeMiddle_txhd1__eQzXR","points":"HomeMiddle_points__J+BX7","span":"HomeMiddle_span__OmEZA"};